import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiService } from '@/services/api/apiService';

interface CustomSearchCustomerAreaManagerReviewsSlice {
    [x: string]: string | undefined;
    id: any;
    customerName: any;
    customerRating: any;
    customerReviewComment: string;
    averageRatingPerCook: any
}

interface CustomSearchCustomerAreaManagerReviewsState {
    data: CustomSearchCustomerAreaManagerReviewsSlice[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_FOOD_ORDER_PORT;
const URL = import.meta.env.VITE_API_FOOD_ORDER_URL;

export const customSearchCustomerAreaManagerReviews = createAsyncThunk<
    CustomSearchCustomerAreaManagerReviewsSlice[],
    { areaManagerId: any },
    { rejectValue: string }
>(
    'CustomSearchCustomerAreaManagerReviews/customSearchCustomerAreaManagerReviews',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>(
                'custom_search_customer_areamanager_review',
                PORT,
                URL,
                config
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

const initialState: CustomSearchCustomerAreaManagerReviewsState = {
    data: [],
    loading: false,
    error: null,
};

export const CustomSearchCustomerAreaManagerReviewsSlice = createSlice({
    name: 'CustomSearchCustomerAreaManagerReviews',
    initialState,
    reducers: {
        clear: (state) => {
            state.data = [];
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(customSearchCustomerAreaManagerReviews.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                customSearchCustomerAreaManagerReviews.fulfilled,
                (state, action: PayloadAction<CustomSearchCustomerAreaManagerReviewsSlice[]>) => {
                    state.loading = false;
                    state.data = action.payload;
                }
            )
            .addCase(customSearchCustomerAreaManagerReviews.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch food items';
            });
    },
});

export default CustomSearchCustomerAreaManagerReviewsSlice.reducer;
